import styled from "styled-components";
import { ICON_NOC, ICON_NOS } from "../../../utils/icons";
import { th } from "../../../utils/helpers";
import { useDashboardContext } from "../../../context/dashboard_context";
import { StyledIcon } from "../../../styles";


const ProductSummary = () => {

      const { dashboardData } = useDashboardContext();

      const { productSummary: { noOfSuppliers, noOfProducts } = {} } = dashboardData;

      const sales = [
            { title: 'Number of Suppliers', icon: ICON_NOS, amount: noOfSuppliers, color: '#24B8F1', border: 'border-end' },
            { title: 'Number of Products', icon: ICON_NOC, amount: noOfProducts, color: '#817AF3CC', border: 'border-0' },
      ];
      return (
            <StyledProductSummary>
                  <div className="main-container">
                        <h4 className="grey-bold-text mb-4">
                              Product Summary
                        </h4>
                        <div className="row justify-content-center">
                              {
                                    sales?.map(({ title, icon, amount, color, border }, i) =>
                                          <div className={`col-6 px-3 mb-3 text-center ${ border }`} key={i}>
                                                <StyledIcon
                                                      color={color}
                                                >
                                                      {icon}
                                                </StyledIcon>
                                                <div className="grey-text">
                                                      <h4 className="small m-0"> {th(amount || 0)} </h4>
                                                      <p className="small"> {title}</p>
                                                </div>
                                          </div>
                                    )
                              }
                        </div>
                  </div>
            </StyledProductSummary>
      );
};

export default ProductSummary;

const StyledProductSummary = styled.div`
      


`;